import React from "react"
import FontAwesome from "react-fontawesome"

export default function CaptionTable({ text }) {

  return (
    <caption>
      <FontAwesome name="angle-right" />&nbsp;
      <FontAwesome name="angle-right" />&nbsp;
      <FontAwesome name="angle-right" />&nbsp; { text }
    </caption>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/CaptionTable.js